import axios from "axios";

export async function updateCropCycle({ commit }, payload) {
  try {
    const { data } = await axios.post(`crops/crop-data-pwa`, payload);
    return data;
  } catch (e) {
    return e;
  }
}


export async function getCropCycle({ commit }, payload) {
  try {
    const { data } = await axios.post(`crops/get-crop`, {crop:payload});
    return data;
  } catch (e) {
    return e;
  }
}

export async function getLastCrop({ commit }, payload) {
  try {
    const { data } = await axios.get(`crops/get-last-crop/${payload}`);
    return data;
  } catch (e) {
    return e;
  }
}